module.exports = __webpack_public_path__ + "media/img/post-sample-image-541d5c35.jpg";